import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { MapPinIcon, BeerIcon } from 'lucide-react';
const ridePages = [{
  path: '/best-rides',
  icon: MapPinIcon,
  label: '5 Best MI Rides',
  color: '#22c55e',
  description: 'Scenic routes to explore'
}, {
  path: '/biker-bars',
  icon: BeerIcon,
  label: 'Great MI Biker Bars',
  color: '#a855f7',
  description: 'Community hangout spots'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function RidesHub() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-312">
      <PageHeader title="Rides & Community" subtitle="Explore Michigan on two wheels" showBack={false} data-id="element-313" />

      <main className="px-4 py-6" data-id="element-314">
        <motion.div className="space-y-3" variants={container} initial="hidden" animate="show" data-id="element-315">
          {ridePages.map(page => {
          const Icon = page.icon;
          return <motion.button key={page.path} variants={item} onClick={() => navigate(page.path)} className="w-full flex items-center gap-4 bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 text-left active:bg-[#252525]" whileTap={{
            scale: 0.98
          }} data-id="element-316">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: `${page.color}15`
            }} data-id="element-317">
                  <Icon className="w-6 h-6" style={{
                color: page.color
              }} data-id="element-318" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-319">
                  <p className="font-semibold text-white" data-id="element-320">{page.label}</p>
                  <p className="text-sm text-[#a3a3a3]" data-id="element-321">{page.description}</p>
                </div>
                <div className="text-[#a3a3a3]" data-id="element-322">→</div>
              </motion.button>;
        })}
        </motion.div>

        {/* Featured Ride */}
        <motion.div className="mt-6 bg-gradient-to-br from-[#22c55e]/20 to-[#22c55e]/5 border border-[#22c55e]/30 rounded-2xl p-5" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} data-id="element-323">
          <p className="text-[#22c55e] text-xs font-semibold mb-2" data-id="element-324">
            FEATURED RIDE
          </p>
          <h3 className="text-white font-bold text-lg mb-2" data-id="element-325">
            Tunnel of Trees (M-119)
          </h3>
          <p className="text-[#a3a3a3] text-sm mb-3" data-id="element-326">
            20 miles of winding road through a canopy of trees along Lake
            Michigan. One of America's most scenic drives.
          </p>
          <button onClick={() => navigate('/best-rides')} className="text-[#22c55e] font-semibold text-sm" data-id="element-327">
            View All Rides →
          </button>
        </motion.div>
      </main>
    </div>;
}